/**
 * Hotel Create/Edit forms. Attributes (chain, category, PMS, lock system,
 * payment processor) are shared by every lead of the hotel.
 */

import React from 'react';
import {
  Create,
  Edit,
  NumberInput,
  SimpleForm,
  TextInput,
  useTranslate,
  required,
  maxLength,
} from 'react-admin';
import { Grid } from '@mui/material';
import { MyToolbar } from '@/components/forms';
import { LookupAutocompleteInput } from '@/features/leads/components/LeadInputs';

const Half = ({ children }: { children: React.ReactNode }) => (
  <Grid item xs={12} md={6}>{children}</Grid>
);

const HotelFormFields = () => {
  const translate = useTranslate();
  const f = (key: string) => translate(`resources.hotels.fields.${key}`);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextInput
          source="name"
          label={f('name')}
          validate={[required(), maxLength(300)]}
          fullWidth
          helperText={false}
        />
      </Grid>
      <Half><LookupAutocompleteInput source="hotelChainId" resource="hotel-chains" label={f('hotelChainName')} /></Half>
      <Half><LookupAutocompleteInput source="hotelCategoryId" resource="hotel-categories" label={f('hotelCategoryName')} /></Half>
      <Half><LookupAutocompleteInput source="pmsSystemId" resource="pms-systems" label={f('pmsSystemName')} /></Half>
      <Half><LookupAutocompleteInput source="lockSystemId" resource="lock-systems" label={f('lockSystemName')} /></Half>
      <Half><LookupAutocompleteInput source="paymentProcessorId" resource="payment-processors" label={f('paymentProcessorName')} /></Half>
      <Grid item xs={12}>
        <TextInput source="address" label={f('address')} fullWidth helperText={false} />
      </Grid>
      <Half><TextInput source="city" label={f('city')} fullWidth helperText={false} /></Half>
      <Half><TextInput source="region" label={f('region')} fullWidth helperText={false} /></Half>
      <Half><TextInput source="country" label={f('country')} fullWidth helperText={false} /></Half>
      <Half><NumberInput source="latitude" label={f('latitude')} fullWidth helperText={false} /></Half>
      <Half><NumberInput source="longitude" label={f('longitude')} fullWidth helperText={false} /></Half>
      <Grid item xs={12}>
        <TextInput source="notes" label={f('notes')} multiline rows={4} fullWidth helperText={false} />
      </Grid>
    </Grid>
  );
};

export const HotelEdit = () => (
  <Edit mutationMode="pessimistic" redirect="list">
    <SimpleForm toolbar={<MyToolbar resource="hotels" />}>
      <HotelFormFields />
    </SimpleForm>
  </Edit>
);

export const HotelCreate = () => (
  <Create redirect="list">
    <SimpleForm toolbar={<MyToolbar resource="hotels" />}>
      <HotelFormFields />
    </SimpleForm>
  </Create>
);
